import React from 'react';
import Translation from '../../../translation/translation';
import { show as showFreeMobileFittingLightbox } from '../../../../../_flux/actions/free_mobile_fitting_light_box_actions';
import getTranslatedText from '../../../../helper/get_translated_text';

function FittingPromotion(props) {
  return props.fittingPromotion.promotionName === 'free_mobile_fitting' ? (
    <div className="mobile-free-fitting">
      <div className="mobile-free-fitting__image mobile-free-fitting__image--widthless">
        <img
          className=""
          src={TYROOLA.globals.staticImagesUrl + 'images/navigation/level_2/mobile_fitter.svg'}
          width="24"
        />
      </div>
      <div className="mobile-free-fitting__text">
        <Translation translationKey="product-tile-notification-free-mobile-fitting-available-promotion" />
        <br />
        <Translation
          tagName="span"
          className="mobile-free-fitting__learn-more"
          translationKey="product-tile-notification-free-mobile-fitting-available-learn-more"
          onClick={showFreeMobileFittingLightbox}
        />
      </div>
    </div>
  ) : (
    <div className="product-tile__free-fitting-notification product-tile__notification">
      <img
        className="hidden-xs"
        src={TYROOLA.globals.staticImagesUrl + 'images/navigation/level_2/how_fitting_works.svg'}
        width="24"
      />
      {promotionText(props)}
    </div>
  );
}

function promotionText(props) {
  let transPromotionText = 'product-tile-free-fitting-available-in';
  if ('next_day_fitting' === props.fittingPromotion.promotionName) {
    transPromotionText = 'product-tile-next-day-fitting-available-in';
  }

  return (
    <span className="product-tile__next-day">
      {getTranslatedText(transPromotionText)}
      <span onClick={props.onOpenFSFClick}>
        <Translation className={'product-tile__fitting-station'} translationKey="product-tile-selected-tyroola-fitting-shops" />
      </span>
    </span>
  );
}

export default FittingPromotion;
